import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";

import { ApiService } from './api.service';
import { JwtService } from './jwt.service';
import { User } from '../models';
import { Observable ,  BehaviorSubject ,  ReplaySubject } from 'rxjs';
import {map, distinctUntilChanged, tap} from 'rxjs/operators';
import {HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private currentUserSubject = new BehaviorSubject<User>({} as User);
  public currentUser = this.currentUserSubject.asObservable().pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
      private http: HttpClient,
      private apiService: ApiService,
      private jwtService: JwtService,
  ) {}

  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next({} as User);
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);
  }
  
  getMerchant(): String {
    return window.localStorage['merchantuserid'];
  }

  getuserID(): String {
    return window.localStorage['merchantid'];
  }

  orderID(): String {
    return window.localStorage['orderid'];
  }

     // Order verify

     payment(credentials): Observable<User> {   
 
      return this.apiService.get('payment/merchants/'+ this.getMerchant() +'/merchant-users/' + this.getuserID() + '/orders/' + this.orderID() ,credentials )
          .pipe(map(
              data => {  
                  return data;
              }
          ));
  }
 
 
}